import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetCouponList, useCoupon } from '../../common/actions/moreAction';
import { SetCurrentPage } from "../../common/actions/pageAction";
import { getCouponObject, isEmpty } from "../../common/cores";
import CouponItem from "./CouponItem"

const CouponContent = props => {
  const { isAuthenticated, coupon } = props;
  const couponList = isEmpty(coupon.list) ? [] : coupon.list;
  const [popup, setPopup] = useState(false);
  const [ activeCouponId, setActiveCouponId ] = useState("")
    
  const GetCouponList = () => {
        props.GetCouponList();
    }

    useEffect(() => {
        if(isAuthenticated){
            GetCouponList();
        }
    }, [isAuthenticated]);

    const onShowResult = () => {
        GetCouponList();
    }

    const onActiveId = (id) => {
        setActiveCouponId(id);
        onPopup();
    }

    const onUseCoupon = () => {
        props.useCoupon(activeCouponId);
        onPopup();
    }

    const onPopup = () => {
        setPopup(!popup);
      };

    const [couponModalShow, setCouponUseModal] = useState(false)

    const CouponUseModal = () => {
      setCouponUseModal(!couponModalShow)
    }
    

  return (
    <Fragment>
      <div data-v-8a9c4d9d="" className="rightContent homePage" style={{ float: "left", width: "100%" }}>
            <div data-v-8a9c4d9d="" className="contents" style={{ maxWidth: "1920px", margin: "auto" }}>
                <div data-v-8a9c4d9d="" className="main_content_continer">
                    <div data-v-7f3aef84="" data-v-8a9c4d9d="" className="main-content padding-15">
                        <div data-v-7f3aef84="" className="aniFrame">
                            <div data-v-7f3aef84="" className="titlePic">
                                <div data-v-7f3aef84="" className="titlePwrapper text-center">
                                    <div data-v-7f3aef84="" className="leftZone"><span className="Logo"></span><span>쿠폰</span></div>
                                    <div data-v-7f3aef84="" className="line m-d-none"></div>
                                </div>
                            </div>
                            <div data-v-7f3aef84="" className="titlePwrapper text-center">
                                    <div data-v-7f3aef84="" className="leftZone"><span className="Logo"></span><span>쿠폰 이벤트 {isEmpty(couponList) ? 0 : couponList.length}개</span></div>
                            </div>

                            <div data-v-7f3aef84="" className="main_content"> 

                                <div data-v-0838e822="" className = "main_content v_deep_deposit">
                                    <div data-v-0838e822="" className = "main_content_wrap main_content_wrap_notice deposit">
                                        <div data-v-0838e822="">
                                            <div data-v-0838e822="" className = "fundFrame noticeFrame d-flex flex-wrap justifyEvently white-text text-center">
                                              {/* <span className="text-center">쿠폰 이벤트 {isEmpty(couponList) ? 0 : couponList.length}개</span> */}
                                            </div>
                                            <div data-v-0838e822="" className = "fundFrame noticeFrame d-flex flex-wrap justifyEvently justify-content-center">
                                            {
                                                !isEmpty(couponList) ?
                                                    couponList.map((item, index) => {
                                                        const couponObj = getCouponObject(item);
                                                        return <CouponItem data = {couponObj} onActiveId={onActiveId} key={index} />
                                                    })
                                                    :
                                                    <div data-v-35afea22="" className="box_coupon margin-30px-top">
                                                        <div className="position-relative " data-v-35afea22="">
                                                        <div data-v-35afea22="" className="lottery_result">
                                                            <strong style={{ textAlign: "center", fontSize: "1.5rem" }}>
                                                                쿠폰이 없습니다.
                                                                <br />
                                                            </strong>
                                                        </div>
                                                        </div>
                                                    </div>
                                            }
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>


        <div
            className="dialog z-2"
            style={{
            display: popup ? "flex" : "none",
            backgroundColor: !popup && "#00000000",
            transition: "0.5s",
            scale: popup ? "1" : "0"
            }}
            >
                <div className="container popup_color" style={{ display: "block" }}>
                <div className="padding-20 d-flex">
                    <img
                    src="../images/question.png"
                    style={{ margin: "20px auto 0 auto" }}
                    alt=""
                    />
                </div>
                <div className="justify-center  d-flex betting_modal_text">
              <span style={{ width: "100%", textAlign: "center" }}>
                쿠폰을 사용하시겠습니까?
              </span>
            </div>
            <div className=" d-flex w-100 justify-content-center padding-15 betting_modal_text">
              <span className="popup-btn" onClick={onUseCoupon}>
                네
              </span>
              <span className="popup-btn" onClick={onPopup}>
                아니오
              </span>
            </div>
          </div>
        </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.user.isAuthenticated, 
  coupon: state.more.coupon,
});

export default connect(
  mapStateToProps,
  { SetCurrentPage, 
    GetCouponList, 
    useCoupon }
)(CouponContent);



// WEBPACK FOOTER //
// ./src/components/account/CouponContent.js